<template>
  <div class="cloud page-wrapper">
    <el-image
      class="banner"
      style="width: 100%;"
      :src="require('../../assets/app_banner.png')"
      fit="scale-down">
    </el-image>

    <div class="container">
      <div class="row">
        <el-row class="section1" :gutter="40">
          <el-col :span="12" :xs="{ span: 24 }">
            <img src="../../assets/app_image.png" alt="">
          </el-col>
          <el-col :span="12" :xs="{ span: 24 }">
            <h2>什么是 All in One App?</h2>
            <div>
              AI MORE是大于智能的一款移动应用, 是连接和控制智能产品的必要配套。它完全免费, 简单操作，方便快捷。将你所需要的所有智能设备，不论品牌，不论型号，只要是大于智能合作的智能家居，你就能在一个APP同时操控，进行你的智能生活。
            </div>
          </el-col>
        </el-row>
        <h2 class="section2">主要功能</h2>
        <el-row class="section3" :gutter="24">
          <el-col :span="8" :xs="{ span: 24 }">
            <img src="../../assets/app_icon1.png" alt="">
            <h3>账号功能</h3>
            <div>
              <p>支持免注册功能，无需注册即可使用App；</p>
              <p>支持邮箱、手机注册登录；</p>
              <p>支持主流的三方登录，包括微信、QQ、Apple等；  </p>
            </div>
          </el-col>
          <el-col :span="8" :xs="{ span: 24 }">
            <img src="../../assets/app_icon2.png" alt="">
            <h3>家庭管理</h3>
            <div>
              <p>支持家庭成员管理, 可将自己的家庭分享给自己的亲人, 并设置不同的权限； </p>
              <p>支持家庭天气信息, 实时了解当地天气情况和空气质量等；</p>
            </div>
          </el-col>
          <el-col :span="8" :xs="{ span: 24 }">
            <img src="../../assets/app_icon3.png" alt="">
            <h3>设备管理</h3>
            <div>
              <p>支持市场上最全的协议能力配网, 支持自动检测新设备, 一键完成配网；</p>
              <p> 支持手动控制、语音控制（包括 Amazon Echo、Google Home等跨平台的第三方语音控制；</p>
              <p>支持设备分享，您可将设备分享给您的亲人或朋友；  </p>
            </div>
          </el-col>
          <el-col :span="8" :xs="{ span: 24 }">
            <img src="../../assets/app_icon4.png" alt="">
            <h3>智能功能模块</h3>
            <div>
              <p>支持一键执行、自动化, 将家里的设备联动起来, 体验真正的智慧生活服务。</p>

            </div>
          </el-col>
          <el-col :span="8" :xs="{ span: 24 }">
            <img src="../../assets/app_icon5.png" alt="">
            <h3>消息推送</h3>
            <div>
              <p>推送服务集成通道：支持友盟、Google等推送通道, 发送运营推送和产品的告警推送; </p>
              <p>支持免打扰设置：自定义推送免打扰时段。</p>
            </div>
          </el-col>
          <el-col :span="8" :xs="{ span: 24 }">
            <img src="../../assets/app_icon6.png" alt="">
            <h3>常见问题与反馈</h3>
            <div>
              <p>查看 App 常见问题：用户可查看使用 App 中遇到的常见问题； </p>
              <p>反馈问题：用户提交对 App 的意见反馈； </p>
              <p>用户日志上传：IOS支持用户上传日志，以定位和解决用户在使用过程中遇到的问题。</p>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.section1 {
  margin: 100px 0;

  .el-col {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    img {
      width: 100%;
    }
  }
  .el-col:last-child {
    h2 {
      margin: 50px 0;
    }
    & > div {
      line-height: 1.5;

    }
  }
}

.section2 {
  text-align: center;
  margin: 40px 0 60px;
}

.section3 {
  margin: 40px 0 100px;
  .el-col {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    margin: 16px 0;

    h3 {
      margin: 16px 0;
      font-size: 22px;
      font-weight: normal;
    }

    p {
      line-height: 1.5;
      font-size: 14px;
    }
  }
}

@media screen and (max-width: 991px) {
  .section3 {
    img {
      height: 56px;
    }
  }
}
</style>